<template>
  <DetailsGrid class="!grid-cols-[9fr_11fr]">
    <DetailsColumn>
      <BasuppgifterSection />
    </DetailsColumn>
    <DetailsColumn>
      <PensionsplanerSection />
      <ForsakringsavtalSection />
      <KompletterandePremierSection />
    </DetailsColumn>
  </DetailsGrid>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

import { DetailsColumn, DetailsGrid } from "@/layout";
import { useApi } from "@/composables/useApi";

import {
  BasuppgifterSection,
  ForsakringsavtalSection,
  KompletterandePremierSection,
  PensionsplanerSection,
} from ".";
import { useArbetsgivareStore } from "../store";

const arbetsgivareStore = useArbetsgivareStore();
const apiClient = useApi();

onMounted(() => {
  if (!arbetsgivareStore.hasFetchedNyckeltal) {
    arbetsgivareStore
      .fetchNyckeltal(apiClient)
      .catch((error) => console.error(error));
    arbetsgivareStore
      .fetchAvtal(apiClient)
      .catch((error) => console.error(error));
  }
});
</script>
